import { useSyncExternalStore } from "react";
import { api } from "@/lib/api";

let branch = { receipt_header: "", receipt_footer: "", menu_order: [] };
const subs = new Set();
const emit = () => subs.forEach((s) => s());

export const setBranch = (b) => { branch = { ...branch, ...b }; emit(); };
export const loadBranch = () => api.get("/cabang-settings").then((r) => setBranch(r.data)).catch(() => {});
export const useBranch = () => useSyncExternalStore((cb) => { subs.add(cb); return () => subs.delete(cb); }, () => branch);

// branch receipt texts override the global ones when filled
export const withBranch = (settings, b) => ({
  ...settings,
  receipt_header: b.receipt_header || settings.receipt_header,
  receipt_footer: b.receipt_footer || settings.receipt_footer,
});
